/**
 * @file  zipcode/index.ts
 * @description  zipcode service to manage all the zipcode related operations
 *
 * @author dlima (dlima-electron)
 *
 */

/**
 * Imports.
 */
// Modules
import { isEmpty } from 'lodash';
// Models
import { Range, StateZipcode } from './model';
// Data
import data from './data.json';

/**
 * get sample data from json file
 */
const sample = (): StateZipcode => {
  return data;
};

/**
 * Validate if zipcode is valid for the selected state
 * @param state
 * @param zipcode
 * @returns flag that indicates if zipcode is valid
 */
export const validateZipcode = (state: string, zipcode: number): boolean => {
  if (process.env.REACT_APP_VALIDATE_ZIPCODE !== 'true') {
    return true;
  }

  let isValid = false;
  const data = sample();

  if (!isEmpty(state)) {
    if (data[state]) {
      data[state].zipcodeRange.forEach((range: Range) => {
        if (range.min === 0 || (zipcode >= range.min && zipcode <= range.max)) {
          isValid = true;
        }
      });
    }
  }

  return isValid;
};

export const formatZipCode = (zipcode: string) : string => {
  if (zipcode.indexOf('-') > 0) {
    return zipcode.split('-')[0];
  }

  return zipcode;
};
